import { Controller } from "@hotwired/stimulus"

// Progressive-enhancement scroll reveal for the marketing home page.
// On connect we arm the hidden→shown transition (by adding `js-reveal` to the
// root element), then reveal each `item` target as it scrolls into view. With
// no JS — or reduced motion — the CSS keeps everything visible, so content is
// never hidden from crawlers or assistive tech.
export default class extends Controller {
  static targets = ["item"]

  declare readonly itemTargets: HTMLElement[]
  private observer?: IntersectionObserver

  connect() {
    const prefersReduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches

    if (prefersReduced || !("IntersectionObserver" in window)) {
      this.itemTargets.forEach((el) => el.classList.add("in"))
      return
    }

    this.element.classList.add("js-reveal")

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in")
            this.observer?.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" },
    )

    this.itemTargets.forEach((el) => this.observer!.observe(el))
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
